import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';

export class PrintingCertifiedResultDto {
    receiptId: number;
    provider: string;
    process: string;
    processId: number;
    @Type(() => Date)
    emailDate: Date;
    @Type(() => Date)
    submittedDate: Date;
    community: string;
    trackingStatus: string;
    orderNumber: string;
    recordNumber: string;
    receiptNumber: string;
    trackingNumber: string;
    @Type(() => Date)
    certifiedReceiptDate: Date;
    @Type(() => FileInfoDisplayResultDto)
    submittedFileInfo: FileInfoDisplayResultDto;
    @Type(() => FileInfoDisplayResultDto)
    certifiedReceiptFileInfo: FileInfoDisplayResultDto;
}
